<section
  class="bg-black/65 bg-[url('/assets/images/contact.jpg')] bg-blend-multiply bg-cover bg-center min-h-[50vh] flex flex-col items-center justify-center text-white text-center px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="flex flex-col items-center container mx-auto">
    <h1 class="font-bold text-3xl lg:text-5xl mb-2">
      Move Tesla metal at the speed of electrons.
    </h1>
    <p class="text-white font-semibold text-center text-lg lg:text-xl">
      Skip the auctions, phone-tag, and tire-kickers—receive a binding cash
      offer in under 30 minutes and close the deal in our secure chat.
    </p>
    <!-- <div class="flex flex-col md:flex-row gap-3 mt-3">
      <button
        class="bg-OUT-Blue text-white font-medium px-5 py-1.5 rounded-full"
      >
        Get My Offer
      </button>
      <button
        class="border border-white text-white font-medium px-4 py-2 rounded-full"
      >
        Apply as Buying Dealer
      </button>
    </div> -->
    <p class="italic mt-5">Built by Tesla people, for Tesla people.</p>
  </div>
</section>

<section class="py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto flex flex-col-reverse gap-5 lg:gap-10 md:flex-row items-center"
  >
    <div class="w-full flex-1">
      <h2 class="text-3xl lg:text-4xl font-bold mb-3">
        Why Sellers & Selling Dealers Love It
      </h2>
      <ul class="list-image-[url('/assets/images/checkmark.svg')] pl-5 text-lg">
        <li>
          <strong>Guaranteed number in ≤30 min</strong> - Our AI routes your VIN
          to a nationwide Tesla-only buyer desk.
        </li>
        <li>
          <strong>OUT-CONNECT™ data pulls</strong> - live odometer, trim,
          battery health; no manual entry.
        </li>
        <li>
          <strong>No listings, no fees up front</strong> - accept the offer only
          if you like the price.
        </li>
        <li>
          <strong>Secure Campfire chat</strong> - talk to the buyer, arrange
          pickup, finish paperwork—all logged and exportable.
        </li>
        <li>
          <strong>Fraud shield</strong> - - Stripe Identity checks the buyer’s
          ID before money changes hands.
        </li>
      </ul>
    </div>
    <div class="flex-1">
      <img
        src="/assets/images/OUT-tesla-2.jpg"
        alt="Tesla Cash Offer"
        class="w-full h-auto mt-8 rounded-lg shadow-lg"
      />
    </div>
  </div>
</section>

<section class="bg-gray-100 py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto flex flex-col gap-5 lg:gap-10 md:flex-row items-center"
  >
    <div class="flex-1">
      <img
        src="/assets/images/OUT-tesla-12.jpg"
        alt="Tesla Cash Offer"
        class="w-full h-auto mt-8 rounded-lg shadow-lg"
      />
    </div>
    <div class="flex-1">
      <h2 class="text-3xl lg:text-4xl font-bold mb-3">
        Why Buying Dealers Sign Up
      </h2>
      <ul class="list-image-[url('/assets/images/checkmark.svg')] pl-5 text-lg">
        <li>
          <strong>Fresh, owner-direct inventory</strong> - see every Tesla that
          hits our platform first.
        </li>
        <li>
          <strong>Real-time alerts (SMS & email)</strong> - no more waiting for
          auction results or phone calls.
        </li>
        <li>
          <strong>Battery-verified units</strong> - OUT-CONNECT™ pulls BMS data
          so you know true range and pack health (your auction can’t).
        </li>
        <li>
          <strong>License‐verified marketplace</strong> - - Only licensed
          dealers get full access; we cross-check state dealer numbers + Stripe
          ID.
        </li>
      </ul>
    </div>
  </div>
</section>

<section class="py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto flex flex-col-reverse gap-5 lg:gap-10 md:flex-row items-center"
  >
    <div class="flex-1">
      <h2 class="text-3xl lg:text-4xl font-bold mb-3">
        How It Works (30-Minute Flow)
      </h2>
      <ul
        class="list-decimal marker:text-OUT-Blue marker:pr-1 marker-slice-5 space-y-1.5 list-inside text-lg"
      >
        <li>
          <strong>VIN + ZIP</strong> - seller drops two fields; OUT-CONNECT
          fills in the rest.
        </li>
        <li>
          <strong>Bid Blast</strong> - offer request pings all subscribed
          buyers; highest bid auto-wins when timer ends or seller clicks
          “Accept.”
        </li>
        <li>
          <strong>Secure Chat Room</strong> - system spins up a private Campfire
          channel with seller, winning dealer, and our concierge bot.
        </li>
        <li>
          <strong>Identity & License Check</strong> - Stripe verifies seller’s
          ID; we verify dealer license; deal is logged.
        </li>
        <li>
          <strong>Funds & Pickup</strong> - wire or cashier’s check, signed
          docs, and pickup in ≤48 hrs.
        </li>
      </ul>
    </div>
    <div class="flex-1">
      <img
        src="/assets/images/OUT-tesla-4.jpg"
        alt="Tesla Cash Offer"
        class="w-full h-auto mt-8 rounded-lg shadow-lg"
      />
    </div>
  </div>
</section>

<!-- Pricing -->
<section class="bg-gray-50 py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container mx-auto">
    <h2 class="text-3xl lg:text-4xl font-bold mb-3 text-center">
      Pricing & Business Model
    </h2>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
      <div
        class="border bg-gray-50 rounded-lg shadow-sm p-4 flex flex-col justify-between min-h-[190px]"
      >
        <div>
          <h3 class="font-semibold text-xl">Starter Dealer</h3>
          <p class="text-sm text-gray-600">For new dealers</p>
        </div>
        <div>
          <p>
            <span class="text-2xl font-bold">$199</span
            ><span class="text-xs"> per month</span>
          </p>
          <!-- <button
            disabled title="Coming Soon"
            class="w-full bg-OUT-Blue text-white font-medium px-6 py-1.5 rounded-full mt-3"
          >
            Get Started
          </button> -->
        </div>
      </div>

      <div
        class="border bg-gray-50 rounded-lg shadow-sm p-4 flex flex-col justify-between min-h-[190px]"
      >
        <div>
          <h3 class="font-semibold text-xl">Pro Dealer</h3>
          <p class="text-sm text-gray-600">For Volume buyers</p>
        </div>
        <div>
          <p>
            <span class="text-2xl font-bold">$499</span
            ><span class="text-xs"> per month</span>
          </p>
          <!-- <button
            disabled title="Coming Soon"
            class="w-full bg-OUT-Blue text-white font-medium px-6 py-1.5 rounded-full mt-3"
          >
            Get Started
          </button> -->
        </div>
      </div>

      <div
        class="border bg-gray-50 rounded-lg shadow-sm p-4 flex flex-col justify-between min-h-[190px]"
      >
        <div>
          <h3 class="font-semibold text-xl">Seller / Selling Dealer</h3>
          <p class="text-sm text-gray-600">For Off-loading inventory</p>
        </div>
        <div>
          <p>
            <span class="text-2xl font-bold">Free</span>
          </p>
          <!-- <button
            disabled title="Coming Soon"
            class="w-full bg-OUT-Blue text-white font-medium px-6 py-1.5 rounded-full mt-3"
          >
            Get Started
          </button> -->
        </div>
      </div>

      <div
        class="border bg-gray-50 rounded-lg shadow-sm p-4 flex flex-col justify-between min-h-[190px]"
      >
        <div>
          <h3 class="font-semibold text-xl">Doc-Prep Concierge</h3>
          <p class="text-sm text-gray-600">Optional add-on</p>
        </div>
        <div>
          <p>
            <span class="text-2xl font-bold"> — </span>
          </p>
          <!-- <button
            disabled
            title="Coming Soon"
            class="w-full bg-OUT-Blue text-white font-medium px-6 py-1.5 rounded-full mt-3"
          >
            Get Started
          </button> -->
        </div>
      </div>
    </div>

    <div class="w-full overflow-x-auto">
      <table
        class="table-fixed w-full mt-9 lg:mt-16 border-collapse min-w-[750px]"
      >
        <thead class="py-24">
          <tr>
            <th class="text-start px-2 py-5"></th>
            <th class="text-start px-2">Starter Dealer</th>
            <th class="text-start px-2">Pro Dealer</th>
            <th class="text-start px-2">Seller / Selling Dealer</th>
            <th class="text-start px-2">Doc-Prep Concierge</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-y border-gray-300">
            <td class="py-3.5">For</td>
            <td class="px-2">New Dealers</td>
            <td class="px-2">Volume buyers</td>
            <td class="px-2">Off-loading inventory</td>
            <td class="px-2">Optional add-on</td>
          </tr>
          <tr class="border-y border-gray-300">
            <td class="py-3.5">Access Fee</td>
            <td class="px-2">$199 per month</td>
            <td class="px-2">$499 per month</td>
            <td class="px-2">Free</td>
            <td class="px-2">—</td>
          </tr>
          <tr class="border-y border-gray-300">
            <td class="py-3.5">Success Fee</td>
            <td class="px-2">$500 per purchased unit</td>
            <td class="px-2">1% of purchase price (min $500)</td>
            <td class="px-2">0.8% of sale price (min $500)</td>
            <td class="px-2">$179 flat</td>
          </tr>
          <tr class="border-y border-gray-300">
            <td class="py-3.5">Perks</td>
            <td class="px-2">30 bid credits/mo, SMS alerts</td>
            <td class="px-2">Unlimited bids, API feed</td>
            <td class="px-2">No listing, no upfront cost</td>
            <td class="px-2" class="px-2">
              DMV & payoff handled for both sides
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<!-- Call To Action -->
<section
  class="bg-[url('/assets/images/Cybertruck_19.jpg')] bg-black/70 bg-cover bg-center bg-blend-multiply py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div
    class="flex flex-col items-center gap-5 container mx-auto text-center text-white"
  >
    <h2 class="text-3xl font-bold">Ready to get started?</h2>
    <p class="">
      Whether you're a seller looking for a quick cash offer or a dealer wanting
      to expand your inventory, we're here to help.
    </p>
    <!-- Goes To Contact Page for Now -->
    <a
      routerLink="/contact"
      class="w-fit bg-OUT-Blue text-white font-medium px-6 py-1.5 rounded-full hover:bg-blue-700"
    >
      Get Started Now
    </a>
  </div>
</section>
